import { render, staticRenderFns } from "./vehicletrips.vue?vue&type=template&id=428213e2&scoped=true"
import script from "./vehicletrips.js?vue&type=script&lang=js&external"
export * from "./vehicletrips.js?vue&type=script&lang=js&external"
import style0 from "./vehicletrips.vue?vue&type=style&index=0&id=428213e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428213e2",
  null
  
)

export default component.exports